<template>
  <div class="form-group">
    <label>{{ label }}</label>
    <div class="inline-lg">
      <div v-for="option in options" :key="option" class="form-check">
        <label>
          <input type="radio" :checked="value === option" :name="name" v-on:input="$emit('input', $event.target.value)" v-bind:value="option" />
          {{ option }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/shared/components/RadioGroup.vue